export const PROPERTY_NOT_OWNED_ID = 'notOwned';
